import React from 'react';
import { ArrowRight, Play } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="accueil" className="hero-section pt-[70px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-white space-y-6 fade-in">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Apprends à programmer en t'amusant avec Scratchflix !
            </h1>
            <p className="text-xl sm:text-2xl text-white/90">
              La plateforme créée par des élèves de 5ème primaire pour découvrir Scratch
            </p>
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button
                onClick={() => scrollToSection('tutoriels')}
                className="cta-button-primary"
              >
                Découvrir nos tutoriels
                <ArrowRight className="ml-2" size={20} />
              </button>
              <button
                onClick={() => scrollToSection('creations')}
                className="cta-button-secondary"
              >
                <Play className="mr-2" size={20} />
                Voir nos projets
              </button>
            </div>
          </div>

          <div className="flex justify-center lg:justify-end">
            <div className="scratch-cat-container">
              <div className="w-64 h-64 sm:w-80 sm:h-80 bg-white/10 backdrop-blur-sm rounded-3xl flex items-center justify-center border-4 border-white/20">
                <img 
                  src={process.env.PUBLIC_URL + "/ndc-logo.png"}
                  alt="Notre-Dame des Champs Logo"
                  className="max-h-48 max-w-full object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;